<template>
  <form @submit.prevent="submitForm">
    <BaseInput
      label="ID / navn"
      v-model="form.name"
    />

    <BaseFormField label="Publiceringsdato">
      <Datejump v-model="form.publishDate">
        <BaseDatetimePicker v-model="form.publishDate" />
      </Datejump>
    </BaseFormField>

    <BaseFormField label="Ikon">
      <IconPicker
        v-model="form.iconID"
        @change="updateIcon"
      />
    </BaseFormField>

    <BaseInput
      label="Overskrift"
      v-model="form.headline"
      title="Vælg dato"
    />

    <BaseCheckbox
      label="Udsend notifikation"
      v-model="form.sendNotification"
    />

    <BaseTextarea
      label="Beskrivelse"
      v-model="form.description"
    />

    <LocalLinks :form="form" />

    <BaseButton
      full
      label="Gem note"
      :disabled="loading || $v.$invalid"
    />
    <BaseSpinner
      height="40px"
      width="40px"
      v-if="loading"
    />
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import LocalLinks from '../../LocalLinks.vue';
import BaseDatetimePicker from '../../BaseDatetimePicker.vue';
import BaseCheckbox from '../../BaseCheckbox.vue';
import Datejump from '../../Datejump.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import BaseTextarea from '../../BaseTextarea.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseInput from '../../BaseInput.vue';
import IconPicker from '../../IconPicker.vue';
import GlobalNotesService from '../../../services/GlobalNotesService';
import DateFormat from '../../../filters/DefaultDate';


export default {
    name: 'CreateGlobalNotesForm',
    components: {
        IconPicker, BaseInput, BaseFormField, BaseTextarea, BaseButton, BaseSpinner, Datejump, BaseCheckbox, BaseDatetimePicker, LocalLinks,
    },
    data() {
        return {
            loading: false,
            form: {},
        };
    },
    validations: {
        form: {
            name: { required },
            description: { required },
            headline: { required },
            iconID: { required, minValue: val => val >= 100 },
        },
    },
    computed: {
        formattedIconID() {
            return this.form.iconID === -1 ? null : this.form.iconID;
        },
        requestData() {
            return { ...this.form, iconID: this.formattedIconID, publishDate: DateFormat(this.form.publishDate) };
        },
    },
    methods: {
        updateIcon(icon) {
            this.form.iconID = icon.id;
        },
        resetForm() {
            this.form = {
                iconID: -1,
                name: '',
                publishDate: window.moment().add(1, 'day').startOf('day').format(),
                headline: '',
                description: '',
                sendNotification: true,
                links: [],
            };
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Ikke alle felter er udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;

                const payload = await GlobalNotesService.create(this.requestData);

                this.$snotify.success(`${payload.name} er oprettet`);
                this.loading = false;
                this.$emit('created', payload);
                this.resetForm();
            } catch (error) {
                this.loading = false;
            }
        },
    },
    created() {
        this.resetForm();
    },
};
</script>
